import HvacLogoReverse, {
	HvacLogoReverseProps as _HvacLogoReverseProps,
} from './HvacLogoReverse';

export { HvacLogoReverse };
export type HvacLogoReverseProps = _HvacLogoReverseProps;
